import {NgModule} from '@angular/core';
import {ImageVariantPipe} from './image-variant.pipe';

@NgModule({
  declarations: [ImageVariantPipe],
  exports: [ImageVariantPipe],
})
export class ImageVariantModule {}
